import { useCallback } from 'react';
import useUser from 'hooks/useUser';
import { useTrailUgcContext } from 'components/trailUgc/TrailUgcContext';
import { addToList, removeFromList } from 'utils/requests/list_requests';

const MAGIC_ID_COMPLETED = 1001;

const useTrailCompleted = (trailId: number) => {
  const user = useUser();
  const {
    ugcState: {
      completed: { connectionId }
    },
    dispatch
  } = useTrailUgcContext();

  const handleCompletedConnectionChanged = useCallback(
    (id?: number) => {
      dispatch({ type: 'TOGGLE_COMPLETED', payload: { connectionId: id, currentUser: user } });
    },
    [user, dispatch]
  );

  const toggleTrailCompleted = useCallback(() => {
    const handleCompletedAdded = (listItem: any) => {
      handleCompletedConnectionChanged?.(listItem.id);
    };

    const handleCompletedRemoved = () => {
      handleCompletedConnectionChanged?.(null);
    };

    if (connectionId) {
      removeFromList(MAGIC_ID_COMPLETED, connectionId, null /* userId - aka me */)
        .then(() => handleCompletedRemoved())
        .catch(err => {
          throw Error(`There was an error removing the trail from your completed list ${err}`);
        });
    } else {
      addToList(MAGIC_ID_COMPLETED, 'trail', trailId, null /* userId - aka me */)
        .then(listItem => handleCompletedAdded(listItem))
        .catch(err => {
          throw Error(`There was an error adding the trail to your completed list ${err}`);
        });
    }
  }, [connectionId, handleCompletedConnectionChanged, trailId]);

  return { connectionId, toggleTrailCompleted };
};

export default useTrailCompleted;
